import React from 'react';
import { useSplash, SPLASH_KEYS } from '../../contexts/SplashContext';
import IntroSplash from './IntroSplash';
import CertificationSplash from './CertificationSplash';
import ProgressSplash from './ProgressSplash';
import AnswerSplash from './AnswerSplash';

/**
 * SplashRenderer component
 * Renders the appropriate splash based on the active splash key
 */
const SplashRenderer: React.FC = () => {
  const { activeSplash, closeSplash } = useSplash();

  if (!activeSplash) {
    return null;
  }

  // Render the appropriate splash based on the key
  switch (activeSplash) {
    case SPLASH_KEYS.INTRO_UPGRADE:
      return <IntroSplash onClose={closeSplash} />;
    case SPLASH_KEYS.CERTIFICATION_TAB_CLICK:
      return <CertificationSplash onClose={closeSplash} />;
    case SPLASH_KEYS.PROGRESS_MILESTONE:
      return <ProgressSplash onClose={closeSplash} />;
    case SPLASH_KEYS.ANSWER_SPLASH:
      return <AnswerSplash onClose={closeSplash} />;
    default:
      return null;
  }
};

export default SplashRenderer;
